const getBrowserResolution = () => {
  return `${window.innerWidth}x${window.innerHeight}`;
};

export default getBrowserResolution;
